export const state = {
    empresaDetails: {}
}

export const mutations = {
    SET_EMPRESA_DETAILS(state, payload) {
        state.empresaDetails = payload
    }
}

export const getters = {
}

export const actions = {
    changeEmpresaDetails({commit}, payload) {
        commit('SET_EMPRESA_DETAILS', payload)
    }
}